// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/politica-tarifaria-flights/list',
    name: 'politica-tarifaria-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/PoliticaTarifaria.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_politica_tarifaria_flights',
    },
  },
  {
    path: '/politica-tarifaria-flights/update',
    name: 'politica-tarifaria-flights-update',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/form/PoliticaTarifaria.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_politica_tarifaria_flights',
    },
  },
]

export default formTable
